import { ComponentType } from 'react';
import styled from 'styled-components';
import toRem from 'utils/toRem';

interface IconImageProps {
  width: number;
  height: number;
  fillColor: string;
}

export interface UnorderedListProps {
  className?: string;
  hasIcon?: boolean;
  IconImage?: ComponentType<IconImageProps>;
  iconColor?: string;
  iconWidth?: number;
  iconHeight?: number;
  listItems: string[];
}

const StyledUnorderedList = styled.ul<UnorderedListProps>`
  li {
    list-style: disc inside;
    display: ${({ hasIcon }) => (hasIcon ? 'flex' : 'list-item')};
    align-items: center;

    span {
      margin-right: ${toRem(6)};
    }

    &:not(:first-child) {
      margin-top: ${toRem(10)};
    }
  }
`;

const UnorderedList = ({
  className = '',
  hasIcon = false,
  IconImage,
  iconColor = 'black',
  iconWidth = 10,
  iconHeight = 10,
  listItems,
}: UnorderedListProps) => (
  <StyledUnorderedList
    className={`cef-ui-unordered-list ${className}`}
    hasIcon={hasIcon}
    listItems={listItems}>
    {listItems.map(item => (
      <li key={item}>
        {hasIcon && IconImage && (
          // Hide the icon from screen readers
          <span className="cef-ui-unordered-list__icon" aria-hidden="true">
            <IconImage
              width={iconWidth}
              height={iconHeight}
              fillColor={iconColor}
            />
          </span>
        )}
        {item}
      </li>
    ))}
  </StyledUnorderedList>
);

export default UnorderedList;
